import React from 'react';
import { Typography } from '@mui/material';
import { bold } from '@styles/fontWeights';

function StaffPercentPosition({
  totalStatff,
}: {
  totalStatff: {
    totalCurrent: number;
    totalDesired: number;
  };
}) {
  const percentage =
    (totalStatff.totalCurrent / totalStatff.totalDesired) * 100;
  const isNoStaffSet =
    totalStatff.totalCurrent === 0 && totalStatff.totalDesired === 0;
  const getColor = () => {
    if (percentage === null || percentage === undefined || isNaN(percentage))
      return 'error.main';
    if (percentage === 0 || percentage === Infinity) return 'error.main';
    if (percentage > 0 && percentage < 100) return 'yellow.main';
    return 'success.main';
  };

  const getStatusText = () => {
    if (percentage === null || percentage === undefined || isNaN(percentage))
      return 'not set';
    if (percentage === Infinity) {
      return 'not set';
    }
    return `${percentage?.toFixed(0)}%`;
  };
  return (
    <>
      <Typography variant="subtitle1" mb={3}>
        <strong>Staff Levels:</strong>{' '}
        <Typography
          component="span"
          sx={{
            fontStyle: 'italic',
            color: getColor(),
            fontWeight: bold,
          }}
        >
          {getStatusText()}
        </Typography>{' '}
      </Typography>
      <Typography
        variant="body1"
        fontSize="14px"
        fontWeight="bold"
        color={isNoStaffSet ? 'error' : 'gray'}
        fontStyle="italic"
      >
        {!isNoStaffSet &&
          `(${totalStatff.totalCurrent}/${totalStatff.totalDesired} Positions Filled)`}
      </Typography>
    </>
  );
}

export default StaffPercentPosition;
